export const accountType = {
  personalSavings: 'Personal Savings',
  personalChecking: 'Personal Checking',
  businessSavings: 'Business Savings',
  businessChecking: 'Business Checking'
};
